module.exports = __webpack_public_path__ + "static/media/1-upload-video.7d7247d5.mp4";